import {View} from "@dp-instant/2d";
import {di} from "@dp-instant/core";
import {TypesGame} from "@game/TypesGame";
import {inject, injectable} from "inversify";
import {Point} from "pixi.js-legacy";
import {Entity} from "tick-knock";
import {InputManager} from "../managers/InputManager";
import {ArrowView} from "./ArrowView";
import {CapitalView} from "./CapitalView";
import {Building} from "@game/coregame/ecs/entities/Building";

@injectable()
export class ArrowsView extends View {
    @inject(TypesGame.inputManager)
    protected inputManager: InputManager;
    protected _arrows: Map<string, ArrowView> = new Map();
    protected _priorTarget: Point | null;

    createArrow(building: Building) {
        const state = building.get(CapitalView);
        if (state) {
            const view = di.get<ArrowView>(TypesGame.views.arrow);
            view.position = state.position.clone();
            this.addChild(view);
            this._arrows.set(building.stateId, view);
        }
    }
    hideArrow(building: Building) {
        const view = this._arrows.get(building.stateId);
        view?.parent?.removeChild(view);
        this._arrows.delete(building.stateId);
    }
    removeAim() {
        this._priorTarget = null;
        this._arrows.forEach(arrow => arrow.parent?.removeChild(arrow));
        this._arrows.clear();
    }
    setAim(point: Point | null) {
        this._priorTarget = point;
    }
    update(event: PointerEvent) {
        if (this._arrows.size > 0) {
            this.setArrows(this._priorTarget || new Point(event.clientX, event.clientY));
        }
    }
    protected setArrows(point: Point) {
        this._arrows.forEach(arrow => arrow.setUpDirection(point));
    }
}
